module.exports = __webpack_public_path__ + "fonts/NouvelR-Semibold.904770c1.ttf";